// extracted by mini-css-extract-plugin
export default {"placeholder":"TextInput_placeholder__VQrTN","textInput":"TextInput_textInput__gvgjo"};